const initSkipLink = () => {
  const headerContainer = document.querySelector('.sui-header')
  if (!headerContainer) return

  let mainContent = document.querySelector('main')
  if (!mainContent) {
    mainContent = document.createElement('div')
    headerContainer.after(mainContent)
  }
  if (!mainContent.id) mainContent.id = `sui-skip-link-target`

  const skipLink = document.createElement('a')
  skipLink.setAttribute('href', `#${mainContent.id}`)
  skipLink.textContent = 'Zum Hauptinhalt springen'
  skipLink.classList.add('sui-header-skip-link', 'sui-button--onlight-primary')
  skipLink.addEventListener('click', () => {
    const toggleButton = document.querySelector('.sui-header-toggle')
    const headerContent = document.querySelector('.sui-header-content')
    if (toggleButton && headerContent) {
      toggleButton.classList.remove('is-active')
      toggleButton.setAttribute('aria-expanded', 'false')
      headerContent.classList.remove('open')
    }
  })

  headerContainer.prepend(skipLink)
}

const initToggleButton = () => {
  const toggleButton = document.querySelector('.sui-header-toggle')
  if (!toggleButton) return

  const toggleHeaderContent = () => {
    toggleButton.classList.toggle('is-active')
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true'
    toggleButton.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')
    const headerContent = document.querySelector('.sui-header-content')
    headerContent.classList.toggle('open')
  }

  toggleButton.setAttribute('type', 'button')
  toggleButton.setAttribute('aria-expanded', 'false')
  toggleButton.setAttribute('aria-label', 'Hauptmenü')

  // init hamburger icon
  toggleButton.classList.add('hamburger', 'hamburger--squeeze')
  toggleButton.innerHTML = '<span class="hamburger-box"><span class="hamburger-inner"></span></span>'

  toggleButton.addEventListener('click', toggleHeaderContent)
}

const initNavMenu = () => {
  const navMenu = document.querySelector('.sui-header-nav')
  if (!navMenu) return

  navMenu.setAttribute('aria-label', 'Hauptmenü')

  /**
   * Initializes the first-level nav items to the desired structure:
   * On large screens, nav items consist of a button that expands/collapses the submenu,
   * on mobile screens, they consist of a simple title/text element.
   */
  navMenu.querySelectorAll('.sui-header-nav-item').forEach((navItem) => {
    const isInitialized = navItem.querySelector('button')
    if (isInitialized) {
      return
    }

    const collapseNavMenuItem = (buttonElem) => {
      buttonElem.setAttribute('aria-expanded', 'false')
      buttonElem.parentElement.classList.remove('open')
    }

    const expandNavMenuItem = (buttonElem) => {
      buttonElem.setAttribute('aria-expanded', 'true')
      buttonElem.parentElement.classList.add('open')
    }

    const initDropdownSubMenu = (menuTitleSpanElement) => {
      // init button for the dropdown menu on large screens
      const dropdownToggleButton = document.createElement('button')

      const toggleSubMenu = () => {
        navMenu.querySelectorAll('.sui-header-nav-item').forEach((otherNavItem) => {
          const otherDropdownToggleButton = otherNavItem.querySelector('button')
          if (!otherDropdownToggleButton) return

          if (dropdownToggleButton === otherDropdownToggleButton) {
            const isExpanded = dropdownToggleButton.getAttribute('aria-expanded') === 'true'
            if (isExpanded) {
              collapseNavMenuItem(dropdownToggleButton)
            } else {
              expandNavMenuItem(dropdownToggleButton)
            }
          } else {
            collapseNavMenuItem(otherDropdownToggleButton)
          }
        })
      }

      dropdownToggleButton.textContent = menuTitleSpanElement.textContent
      dropdownToggleButton.setAttribute('type', 'button')
      dropdownToggleButton.setAttribute('aria-expanded', 'false')
      dropdownToggleButton.addEventListener('click', toggleSubMenu)

      // close submenu when clicking or tabbing outside
      navItem.addEventListener('focusout', (event) => {
        const focusTargetNavItem = event.relatedTarget && event.relatedTarget.closest('.sui-header-nav-item')
        const isFocusInCurrentNavItem = focusTargetNavItem && focusTargetNavItem.classList.contains('open')
        if (isFocusInCurrentNavItem) {
          return
        }
        collapseNavMenuItem(dropdownToggleButton)
      })

      menuTitleSpanElement.before(dropdownToggleButton)
    }

    /**
     * Menu titles can't be h2 elements, as this would break the document's heading structure.
     * However, screen readers should still treat them as headings.
     */
    const menuTitleSpan = navItem.querySelector('span')

    if (!menuTitleSpan) {
      return
    }

    menuTitleSpan.setAttribute('role', 'heading')
    menuTitleSpan.setAttribute('aria-level', '2')

    initDropdownSubMenu(menuTitleSpan)
  })
}

const initHover = () => {
  const CLASS_VISIBLE = 'visible'
  const CLASS_VISIBLE_BEFORE = 'visible-before'

  const navMenuUl = document.querySelector('.sui-header-nav > ul')
  if (!navMenuUl) return

  const showHover = (buttonElem) => {
    const buttonRect = buttonElem.getBoundingClientRect()
    const parentUlRect = buttonElem.closest('ul').getBoundingClientRect()

    const hover = document.querySelector('.sui-header-hover')
    hover.style.width = `${buttonRect.width}px`
    hover.style.transform = `translateX(${buttonRect.left - parentUlRect.left}px)`

    if (hover.classList.contains(CLASS_VISIBLE)) {
      hover.classList.add(CLASS_VISIBLE_BEFORE)
    }
    hover.classList.add(CLASS_VISIBLE)
  }

  navMenuUl.querySelectorAll('button, .sui-header-nav-item > a').forEach((buttonElem) => {
    buttonElem.addEventListener('mouseenter', () => {
      showHover(buttonElem)
    })
  })

  const hover = document.createElement('li')
  hover.classList.add('sui-header-hover')
  hover.setAttribute('aria-hidden', 'true')
  navMenuUl.prepend(hover)
  navMenuUl.addEventListener('mouseleave', () => {
    hover.classList.remove(CLASS_VISIBLE, CLASS_VISIBLE_BEFORE)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initSkipLink()
  initToggleButton()
  initNavMenu()
  initHover()
})
